import * as Yup from 'yup'
import {ExtraLongHTML} from 'Validations'

export const Validation = Yup.object().shape({
  benefitsText: ExtraLongHTML,
  additionalBenefits: Yup.array(),
  customBenefitsTextHtml: ExtraLongHTML,
})
